export default __webpack_public_path__ + "static/media/cubeLine.ff23e87f.gif";